import React, { useState } from "react"
import { Flex, Box, useOutsideClick } from "@chakra-ui/react"
import { colors } from "@app/theme/colors"
import Icon from "@app/components/Icon/Icon"
import ReactSlider from "react-slider"
import { FilterProps } from "@usereactify/search"

export type FilterRangeProps = React.ComponentProps<NonNullable<FilterProps["renderFilterRange"]>>

export const FilterRange: React.FC<FilterRangeProps> = (filter: any) => {
  const ref = React.useRef()
  const [isOpen, setIsOpen] = useState(false)

  useOutsideClick({
    ref: ref,
    handler: () => setIsOpen(false),
  })

  return (
    <Flex position="relative" mr={1} ref={ref}>
      <Flex
        fontSize="15px"
        fontWeight={"medium"}
        alignItems={"center"}
        borderRadius="5px"
        px="16px"
        py={"8px"}
        onClick={() => setIsOpen(!isOpen)}
        cursor="pointer"
        border={`1px solid ${colors.brand.border}`}
      >
        {filter?.filter?.name}
        <Box transform={isOpen ? "rotateX(180deg)" : "rotateX(0deg)"}>
          <Icon ml="10px" name="chevronDown" size="14px"></Icon>
        </Box>
      </Flex>
      {isOpen && (
        <Flex
          zIndex={6}
          bg={"white"}
          px={2}
          pt={3}
          pb={4}
          border={`1px solid ${colors.brand.border}`}
          borderRadius="5px"
          flexDirection={"column"}
          position="absolute"
          top={"100%"}
          left={0}
          maxHeight={"400px"}
          overflow={"auto"}
          width={`250px`}
        >
          <ReactSlider
            {...filter.filterRangeProps?.reactRangeProps}
            className="rs-price-slider"
            ariaLabel={["Lower thumb", "Upper thumb"]}
            ariaValuetext={state => `Thumb value ${state.valueNow}`}
            renderThumb={props => <div {...props} />}
            onAfterChange={value => filter.filterRangeProps.handleChange(value)}
            onChange={() => null}
          />
        </Flex>
      )}
    </Flex>
  )
}

export default FilterRange
